<a
  class="btn btn-action btn-small back-navigation"
  [routerLink]="{ cxRoute: 'priceSupportAgreements' } | cxUrl"
  [queryParams]="sharedService.getQueryParamsLocal('priceSupportAgreements')"
  >
  <i class="fas fa-arrow-left mr-1"></i>
  {{ 'shared.backTo.priceSupportAgreement' | cxTranslate }}
</a>

@if (agreement) {
  <div class="container">
    <div class="card agreement-detail">
      <div class="row card-body agreement-detail-content">
        <div class="col-12 col-sm-6 col-md-4 card-body--label">
          <b>{{ 'priceSupportAgreement.endUserNumber' | cxTranslate }}</b>
          @if (agreement.endCustomer?.orgUnit?.uid) {
            <span>{{ agreement.endCustomer?.orgUnit?.uid }}</span>
          }
        </div>
        <div class="col-12 col-sm-6 col-md-4 card-body--label order-2 order-sm-0">
          <b>{{ 'priceSupportAgreement.startDate' | cxTranslate }}</b>
          @if (agreement.startDate) {
            <span>{{ agreement.startDate | cxDate: 'longDate' }}</span>
          }
        </div>
        <div class="col-12 col-sm-6 col-md-4 card-body--label order-4 order-md-0">
          <b>{{ 'priceSupportAgreement.division' | cxTranslate }}</b>
          @if (agreement.division) {
            <span>{{ agreement.division }}</span>
          }
        </div>
        <div class="col-12 col-sm-6 col-md-4 card-body--label order-1 order-sm-0">
          <b>{{ 'priceSupportAgreement.endUserName' | cxTranslate }}</b>
          @if (agreement.endCustomer?.orgUnit?.name) {
            <span>{{ agreement.endCustomer?.orgUnit?.name }}</span>
          }
        </div>
        <div class="col-12 col-sm-6 col-md-4 card-body--label order-3 order-md-0"></div>
        <div class="col-12 col-sm-6 col-md-4 card-body--label order-5 order-md-0">
          <b>{{ 'priceSupportAgreement.status' | cxTranslate }}</b>
          @if (agreement.stateDisplay) {
            <span>{{ agreement.stateDisplay }}</span>
          }
        </div>
        @if (showWhenPending) {
          <div class="col-auto agreement-detail-actions order-6 text-left">
            <button class="btn btn-primary btn-small mr-3 agreement-action-reject" (click)="rejectAgreement(agreement)">
              {{ 'priceSupportAgreement.reject' | cxTranslate }}
            </button>
            <button class="btn btn-primary btn-small mr-3 agreement-action-accept" (click)="acceptAgreement(agreement)">
              {{ 'priceSupportAgreement.accept' | cxTranslate }}
            </button>
          </div>
        }
        <div class="col-12 col-md agreement-detail-actions order-6">
          @if (showDownloadCSV) {
            <button
              class="btn btn-primary btn-small mt-2"
              (click)="downloadCSV(agreement.orderCode)"
              >
              <i class="fa fa-download"></i>
              {{ 'priceSupportAgreement.downloadCSV' | cxTranslate }}
            </button>
          }
          @if (agreement.externalQuoteDocumentBlob) {
            <button
              class="btn btn-primary btn-small ml-3 mt-2"
              (click)="getTermsAndConditionsPDF(agreement)"
              >
              <i class="fa fa-download"></i>
              {{ 'priceSupportAgreement.termsConditions' | cxTranslate }}
            </button>
          }
        </div>
      </div>
    </div>
  </div>
}

@if (entries) {
  <app-custom-table
    [headers]="headers"
    [columns]="columns"
    rowId="product.code"
    [rows]="entries.results"
    [pagination]="entries.pagination"
    (changePagination)="pageChange($event)"
    [showLoader]="showLoaderOnPagination"
  ></app-custom-table>
} @else {
  @if (!showInitialLoader) {
    @if (!showError404) {
      <app-custom-error [errorMessage]="'shared.noEntries' | cxTranslate"></app-custom-error>
    }
    @if (showError404) {
      <app-custom-error [errorMessage]="'shared.error.notFound404' | cxTranslate"></app-custom-error>
    }
  }
}


@if (showInitialLoader) {
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
}
